<div class="container_dialog">
    <div class="header_popup">
      <div class="title_popup">
        <span>{{"settings.add_notifications_recipients"|translate}}</span>
      </div>
      <button class="close_btn" (click)="closed()">
        <img src="assets/icones/close.svg" alt="">
      </button>
    </div>
    <form class="display_form">
        <div class="input_field">
            <input type="text" [placeholder]="'settings.search_name_email'|translate" [formControl]="userControl" [matAutocomplete]="auto2"
            class="input">
            <mat-autocomplete #auto2="matAutocomplete">
              <mat-option *ngFor="let user of filteredUsers$ | async " [value]="user.name"
                (click)="onUserSelected(user)">
                {{ user.name }}
              </mat-option>
          </mat-autocomplete>
          </div>
    </form>
    <div class="submet_btns">
        <button class="save_btn_pop_up cancel_btn_pop_up" (click)="closed()">
          <span>{{"common.cancel" |translate}}</span>
        </button>
        <button class="save_btn_pop_up blue_btn" (click)="save()">
          <span>{{"common.save" |translate | uppercase}}</span>
          <img alt="" src="assets/icones/arrow_circle_right.svg">
        </button>
      </div>
  </div>
  